module.exports = __webpack_public_path__ + "img/grey_036.16fdd1f7.png";